import "./index.scss";

import { Box, Stack } from "@mui/material";
import CapsuleText from "components/CapsuleText";
import { StrengthProgram } from "models/workoutplan";
import { useEffect, useState } from "react";

import DefinedProgramContainer from "../../components/DefinedProgramContainer";

const StrengthDefinedProgram = (props: {
  headerInfo: any;
  strengthProgram: StrengthProgram;
  isWorkoutPlanTemplate?: boolean;
}) => {
  const { headerInfo, strengthProgram, isWorkoutPlanTemplate = false } = props;
  const [maximumNumberOfSets, setMaximumNumberOfSets] = useState(0);

  useEffect(() => {
    if (strengthProgram) {
      let maxNbSets = 0;
      strengthProgram.exercises.forEach((e) => {
        if (e.sets.length > maxNbSets) maxNbSets = e.sets.length;
      });
      setMaximumNumberOfSets(maxNbSets);
    }
  }, [strengthProgram]);

  return (
    <Box className="strength-defined-program">
      <DefinedProgramContainer headerInfo={headerInfo}>
        <Stack flex={1} direction="row" className="inner-container">
          <Stack gap={1} className="inner-left-container">
            <Stack direction="row" justifyContent="space-between">
              <p className="title">Targets</p>
              <p className="label-text">
                Workouts per week <label className="title">{strengthProgram.per_week}</label>
              </p>
            </Stack>
            <p className="label-text-small">Exercise</p>
            {strengthProgram.exercises?.map((m, i) => (
              <CapsuleText key={`strengthProgramExercise${i}`} text={m.name} />
            ))}
          </Stack>

          <Box className="inner-right-container">
            <Box>
              <Stack>
                <Box maxWidth={"100vw"} overflow="auto">
                  <Stack className="setsArea" gap={1}>
                    <Stack>
                      {Array(maximumNumberOfSets)
                        .fill(0)
                        .map((_m, i) => (
                          <Box key={`setCounter${i}`} className="setNumber">
                            Set {i + 1}
                          </Box>
                        ))}
                    </Stack>
                    <Stack>
                      {Array(maximumNumberOfSets)
                        .fill(0)
                        .map((_m, i) => (
                          <Stack direction={"row"} key={`setHeader${i}`} className="setHeaders">
                            <p>Weight</p>
                            <p>Min Reps</p>
                            <p>Max Reps</p>
                            <p>Rest Time</p>
                          </Stack>
                        ))}
                    </Stack>
                    {strengthProgram?.exercises?.map((m, exerciseIndex) => (
                      <Stack key={`exerciseSetRow${exerciseIndex}`}>
                        {m.sets.map((set, setIndex) => (
                          <Stack
                            key={`exerciseSetCol${exerciseIndex}_${setIndex}`}
                            className={`set-row`}
                          >
                            <span>{set.weight === 9999 ? 0 : set.weight}</span>
                            <span>{set.reps_min}</span>
                            <span>{set.reps_max}</span>
                            <span>{set.rest_time}</span>
                          </Stack>
                        ))}
                        {m.sets.length < maximumNumberOfSets &&
                          Array(maximumNumberOfSets - m.sets.length)
                            .fill(0)
                            .map((m, index) => (
                              <Stack
                                key={`exerciseSetCol${exerciseIndex}_${index}`}
                                className="set-row empty"
                              ></Stack>
                            ))}
                      </Stack>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Stack>
        {!isWorkoutPlanTemplate && (
          <>
            <Box sx={{ height: 10 }} />
            <Stack flex={1} className="inner-container inner-container-2">
              <p className="title">Settings</p>
              <Stack direction="row" className="labels">
                <label>Exercise</label>
                <p>Machine Settings</p>
              </Stack>
              <Stack gap={1}>
                {strengthProgram.exercises?.map((m, i) => (
                  <StrengthItem
                    key={`strengthProgramExerciseSetting${i}`}
                    label1={m.name}
                    label2={m.settings || "-"}
                  />
                ))}
              </Stack>
            </Stack>
          </>
        )}
      </DefinedProgramContainer>
    </Box>
  );
};

const StrengthItem = ({ label1, label2 }) => {
  return (
    <Box className="strength-program-item">
      <p>{label1}</p>
      <label>{label2}</label>
    </Box>
  );
};

export default StrengthDefinedProgram;
